import Service from '@/utils/request';

/**
* 起飞订单
* @param orderId 配送订单ID,simulation: 是否为模拟起飞,默认为false
* @returns 
*/
export const fetchTakeoff = (param) => Service.post('/biz/delivery/task/startFlight', {
            orderId: param.orderId,
            simulation: param.simulation || false,
            appCode: 'WL'
});
/**
 *从收货点返回配送点
 * @param orderId 配送订单ID,simulation: 是否为模拟返航,默认为false
 * @returns 
 */
export const fetchReturnTakeoff = (param) => Service.post('/biz/delivery/task/returnFlight', {
            orderId: param.orderId,
            simulation: param.simulation || false,
            appCode: 'WL'
});
/**
 * 创建物流飞行任务
 * @param orderId 配送订单ID,simulation: 是否为模拟起飞,默认为false,type: 任务类型,0:出航,1: 返程
 * @returns 
 */
export const fetchCreateFlightTask = (param) => Service.post('/biz/delivery/task/createTask', {
            orderId: param.orderId,
            type: param.type || 0,
            simulation: param.simulation || false,
            appCode: 'WL'
});
/**
 * 获取物流任务订单轨迹信息
 * 
 * @param {string} orderId - 订单ID
 * @returns {Promise} 返回包含订单轨迹信息的Promise对象
 */
export const fetchTaskOrderTrace = (orderId) => Service.get('/biz/delivery/task/orderTrace', {
  params:{
    orderId,
    appCode: 'WL'
  }
           
});

export default {
    fetchTakeoff,
    fetchTaskOrderTrace,
    fetchReturnTakeoff,
    fetchCreateFlightTask
}